import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import { LinkColumn } from '../../../components/Table/utils';
import { linkFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { SitePersonCriteriaOrder } from '../../../../gql/typings';

export const linkFirstNameFieldConfig = linkFieldConfig(
  'firstName',
  [
    'id',
    'person.id',
    'person.firstName',
  ],
  ({ localization, openInNewTab }) => ({
    title: localization.formatMessage(Locale.Attribute.First_name),
    additionalTableConfig: {
      width: 150
    },
    sorting: {
      ascend: [SitePersonCriteriaOrder.PERSON_FIRSTNAME_ASC],
      descend: [SitePersonCriteriaOrder.PERSON_FIRSTNAME_DESC],
    },
    render: (record) => <LinkColumn
      text={record.person.firstName}
      url={`/hcp/${record.person.id}`}
      openInNewTab={openInNewTab}
    />,
  })
);

